import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';

export const PlanSet: ITypeSpecificPolicy<types.PlanSet> = {
  fields: {
    createdAt: dateTimeFieldPolicy(),
    updatedAt: dateTimeFieldPolicy()
  }
};
